<h2 class="relative px-[30px] inline-flex justify-center items-center gap-1 w-full !font-bold text-fraud-gray-200 !mb-3 pt-4">
  <button class="absolute left-4 top-4" (click)="matDialogRef.close(false)">
    <mat-icon class="!w-[28px] mat-icon-button-back" [svgIcon]="'button-back'"></mat-icon>
  </button>
  Activate @if (isAmlEnergyActive()) {
    <mat-icon [svgIcon]="'fire'" class="!w-[19px] !h-[23px] text-fraud-red-800 ml-[7px] mr-[3px]"></mat-icon> AML Energy!
  }
</h2>

<div
  class="border border-solid border-fraud-gray-500 bg-white rounded-[6px] p-[2px_8px_2px_8px] flex items-center min-h-[50px] gap-2.5 overflow-hidden mb-[6px] mx-4">
  <div class="flex gap-2 min-w-[78px]">
    <mat-icon class="!min-w-[30px] !w-[30px] !h-[30px]" [svgIcon]="'circle-usdt'"></mat-icon>
    <div class="flex flex-col gap-1">
      <b>USDT</b>
      <span class="text-[11px]">TRC-20</span>
    </div>
  </div>
  <hr class="h-[42px] border-r border-solid border-fraud-gray-500">
  <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-1 justify-between items-center  overflow-hidden" [ngClass]="currentLang === 'ru' ? 'gap-1' : 'gap-2.5'">
    <div class="overflow-hidden w-full">
      <span class="text-xs text-[#94A3A6]">{{ 'pages.add_wallet.title' | translate:{ network: 'TRC-20' } }}</span>
      <input #addressInput formControlName="address" type="text" class="outline-none border-none text-ellipsis w-full">
    </div>
    @if ((form.touched || form.dirty) && form.invalid) {
      <button type="button" (click)="enableForm()" class="border border-solid border-[#022D35] rounded py-2 h-[32px]" [ngClass]="currentLang === 'ru' ? 'min-w-[80px] px-1' : 'min-w-[68px] px-2'" mat-ripple>{{ 'common.buttons.change' | translate }}</button>
    }
    @else {
      <button type="submit" [disabled]="form.invalid || form.pending" class="bg-fraud-red-800 text-white rounded py-2 h-[32px] disabled:pointer-events-none disabled:opacity-30" [ngClass]="currentLang === 'ru' ? 'min-w-[80px] px-1' : 'min-w-[68px] px-2'" mat-ripple>{{ 'common.buttons.save' | translate }}</button>
    }
  </form>
</div>

@if ((form.touched || form.dirty) && form.invalid) {
  <div class="bg-[#F0F3F3] rounded-[8px] p-4 min-h-[234px] mx-4">
    <div class="w-fit bg-fraud-red-800 text-white mb-2 p-[5px_10px] rounded-[27px]">{{ 'common.errors.error_invalid_wallet' | translate }}</div>
    <div class="text-fraud-red-800 leading-[1.2] !mb-0">{{addressErrorMessage() | translate}}</div>
  </div>
} @else {
  <div class="bg-[#F0F3F3] px-2 pb-[10px] rounded-[8px] mx-4">
    <div class="flex justify-between items-center min-h-[37px] text-[#66767A] text-[12px] border-b border-solid border-[#0000001A]">
      <span>Period</span>
      <span class="block bg-[#9AABAE3D] h-[14px] rounded-[4px] w-[130px]"></span>
    </div>
    <div class="flex justify-between items-center min-h-[54px] text-[#66767A] text-[12px] border-b border-solid border-[#0000001A]">
      <span class="leading-[1.4]">
        TRX fees for withdrawal <br>
        <span class="flex items-center">
          transactions
          <mat-icon class="!w-[12px] !h-[12px] !text-[12px] ml-1 pt-[1px]'">info_outline</mat-icon>
        </span>
      </span>
      <span class="block bg-[#9AABAE3D] h-[14px] rounded-[4px] w-[122px]"></span>
    </div>
    <div class="flex justify-between items-center min-h-[46px] text-[#66767A] text-[12px]">
      <span class="flex items-center">
        <span class="text-[16px] font-bold">Cost of</span>
        @if (isAmlEnergyActive()) {
          <mat-icon [svgIcon]="'fire'" class="text-fraud-red-800 ml-[7px] mr-[3px] !w-[15px] !h-[19px]"></mat-icon>
          <span class="text-[16px] font-bold">AML Energy</span>
        }
      </span>
      <span class="block bg-[#9AABAE3D] h-[22px] rounded-[4px] w-[83px]"></span>
    </div>
    <p class="!mb-4 text-[10px] uppercase font-bold text-fraud-gray-500/40 relative overflow-hidden after:absolute after:top-1/2 after:-translate-y-1/2 after:h-[1px] after:w-full after:bg-[#D8D8D8] after:ml-2">
      Package adjustment
    </p>
    <div class="flex gap-[9px]">
      <div class="flex flex-col w-full">
        <span class="text-[10px] leading-1.2 text-[#66767A] mb-[5px] uppercase">Incoming <br> Transactions</span>
        <span class="block bg-[#DBE2E2] h-[35px] rounded-[5px] w-full"></span>
      </div>
      <div class="flex flex-col w-full">
        <span class="text-[10px] leading-1.2 text-[#66767A] mb-[5px] uppercase">Package <br> Period</span>
        <span class="block bg-[#DBE2E2] h-[35px] rounded-[5px] w-full"></span>
      </div>
      <div class="flex flex-col w-full">
        <span class="text-[10px] leading-1.2 text-[#66767A] mb-[5px] uppercase">Outgoing <br> Transactions</span>
        <span class="block bg-[#DBE2E2] h-[35px] rounded-[5px] w-full"></span>
      </div>
    </div>
  </div>
}
